/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Docsmodal_Username3Inputs */

const en_settings_reportingapikeys_docsmodal_username3 = /** @type {(inputs: Settings_Reportingapikeys_Docsmodal_Username3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {Settings_Reportingapikeys_Docsmodal_Username3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_docsmodal_username3 = /** @type {((inputs?: Settings_Reportingapikeys_Docsmodal_Username3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Docsmodal_Username3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_docsmodal_username3(inputs)
});
export { settings_reportingapikeys_docsmodal_username3 as "settings_reportingApiKeys_docsModal_username" }